import MoneyColored from '@spa/shared/svg/money-colored';
import Files from '@spa/shared/svg/files';
import Train from '@spa/shared/svg/train';
import Certificate from '@spa/shared/svg/certificate';

export const valuePropositionItems = [
  {
    title: 'No guarantor, no bureaucracies',
    description:
      'Say goodbye to guarantors, income proofs, and endless calls. Book your stay online effortlessly with Uniplaces from anywhere in the world.',
    icon: Files
  },
  {
    title: 'Safe arrival',
    description:
      'If your property isn’t as listed, report it within 24 hours of your move-in. We’ll freeze your payment and help resolve the issue fast.',
    icon: Train
  },
  {
    title: 'Certificate of Prepaid Accommodation',
    description:
      'Need a document for your visa application? We’ve got you covered with a prepaid accommodation certificate.',
    icon: Certificate
  },
  {
    title: 'Send multiple booking requests, only pay one',
    description:
      'Interested in more than one place? Send multiple booking requests! The first accepted one will be confirmed and paid automatically.',
    icon: MoneyColored
  }
];
